export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20boutique%20display%20with%20designer%20shoes%20on%20pedestals%20and%20folded%20cashmere%20sweaters%20on%20marble%20shelves%2C%20boutique%20interior%20with%20warm%20spotlight%20illumination%2C%20luxury%20retail%20atmosphere%2C%20cream%20walls%20and%20gold%20accents%2C%20editorial%20interior%20photography%20with%20shallow%20depth%20of%20field&width=1800&height=1200&seq=hero-v2-main-2026&orientation=landscape"
          alt="Hipobuy Spreadsheet - Boutique Mode"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-background-50/75 via-background-50/45 to-background-50/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32 text-center">
        <div className="max-w-3xl mx-auto animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/90 text-accent-800 text-xs font-semibold mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            Nouveau — Guide 2026
          </div>

          <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-foreground-900 leading-tight mb-2">
            Hipobuy Spreadsheet
          </h1>
          <p className="font-heading font-semibold text-2xl md:text-3xl lg:text-4xl text-foreground-800 mb-6">
            Le guide complet pour automatiser vos données
          </p>

          <p className="text-sm md:text-base text-foreground-700 max-w-xl mx-auto mb-10 leading-relaxed">
            Découvrez comment utiliser Hipobuy Spreadsheet pour analyser, automatiser et structurer vos données plus efficacement que Google Sheets et Airtable.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              hipobuy spreadsheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3 rounded-full border-2 border-foreground-300/70 text-foreground-800 text-sm md:text-base font-semibold hover:border-primary-400 hover:text-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy it Now
            </a>
          </div>

          <p className="mt-6 text-xs text-foreground-400">Sans installation. Compatible avec tous les outils de spreadsheet modernes.</p>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-fade-in">
        <div className="w-5 h-8 rounded-full border-2 border-foreground-300/40 flex items-start justify-center p-1">
          <div className="w-1 h-2 rounded-full bg-foreground-400/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}